import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Select from "react-select"; // ✅ import react-select

const Vacancies = () => {
  const getTimeAgo = (createdAt) => {
    const createdDate = new Date(createdAt);
    const now = new Date();
    const diffInSeconds = Math.floor((now - createdDate) / 1000);
    if (diffInSeconds < 60) return `Added: ${diffInSeconds} seconds ago`;
    else if (diffInSeconds < 3600) return `Added: ${Math.floor(diffInSeconds / 60)} min ago`;
    else if (diffInSeconds < 86400) return `Added: ${Math.floor(diffInSeconds / 3600)} hour ago`;
    else if (diffInSeconds < 2592000) return `Added: ${Math.floor(diffInSeconds / 86400)} day ago`;
    else if (diffInSeconds < 31536000) return `Added: ${Math.floor(diffInSeconds / 2592000)} month ago`;
    else return `Added: ${Math.floor(diffInSeconds / 31536000)} year ago`;
  };

  const [countries, setCountries] = useState([]);
  const [studyLevels, setStudyLevels] = useState([]);
  const [studyCourses, setStudyCourses] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [studyFaculties, setStudyFaculties] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedFaculty, setSelectedFaculty] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState([]);
  const [collegeNature, setCollegeNature] = useState("");

const [collegeOptions, setCollegeOptions] = useState([]);
const [selectedCollege, setSelectedCollege] = useState([]);
const [isFilterApplied, setIsFilterApplied] = useState(false);


fetch("https://goforen.com/go_foren/get_unique_colleges/")
  .then(res => res.json())
  .then(data => {
    const formattedColleges = data.map(college => ({
      value: college,
      label: college,
    }));
    setCollegeOptions(formattedColleges);
  });


  const [showModal, setShowModal] = useState(false);
  const [applyData, setApplyData] = useState({ name: "", number: "", email: "", country: "" });

  useEffect(() => {
    fetch("https://goforen.com/go_foren/get_Study_Faculty_data/")
      .then((res) => res.json())
      .then((data) => {
        const uniqueFaculties = Array.from(new Set(data.map(item => item.course_name)))
          .map(name => data.find(item => item.course_name === name));
        setStudyFaculties(uniqueFaculties);
      });

    fetch("https://goforen.com/go_foren/get_country_data/")
      .then(res => res.json())
      .then(setCountries);

    fetch("https://goforen.com/go_foren/get_Study_Level_data/")
      .then(res => res.json())
      .then(setStudyLevels);

    fetch("https://goforen.com/go_foren/get_Study_Cource_data/")
      .then(res => res.json())
      .then(data => {
        setAllCourses(data);
        setStudyCourses(data.slice(-2));
      });
  }, []);

  const formatDate = (isoDateStr) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(isoDateStr);
    const day = String(date.getDate()).padStart(2, "0");
    return `${day} ${months[date.getMonth()]}, ${date.getFullYear()}`;
  };

  const handleFilter = () => {
    setIsFilterApplied(true); // ✅ Add this

    let filtered = [...allCourses];

    if (selectedCountry.length > 0 && !selectedCountry.find(c => c.value.toLowerCase() === "anywhere")) {
      filtered = filtered.filter(item =>
        selectedCountry.some(c => item.location.toLowerCase().includes(c.value.toLowerCase()))
      );
    }

    if (selectedFaculty.length > 0 && !selectedFaculty.find(c => c.value.toLowerCase() === "any")) {
      filtered = filtered.filter(item =>
        selectedFaculty.some(f => item.study_faculty === f.value)
      );
    }

    if (selectedLevel.length > 0 && !selectedLevel.find(c => c.value.toLowerCase() === "any")) {
      filtered = filtered.filter(item =>
        selectedLevel.some(l => item.study_level === l.value)
      );
    }

    if (collegeNature) {
      filtered = filtered.filter(
        item =>
          item.college_nature &&
          item.college_nature.toLowerCase().includes(collegeNature.toLowerCase())
      );
    }
if (selectedCollege && selectedCollege.length > 0) {
  filtered = filtered.filter(item =>
    item.college &&
    selectedCollege.some(college =>
      item.college.toLowerCase().includes(college.value.toLowerCase())
    )
  );
}

    // setStudyCourses(filtered);
     setStudyCourses(filtered.slice(0, 2));
  };

  const handleReset = () => {
    setSelectedCountry([]);
    setSelectedFaculty([]);
    setSelectedLevel([]);
    setSelectedCollege([]);
    setCollegeNature("");
    setStudyCourses(allCourses.slice(-2));
      setIsFilterApplied(false); // ✅ Add this

  };

  const handleApplyClick = (courseId) => {
    setApplyData(prev => ({ ...prev, study_course_id: courseId }));
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "number") {
      const onlyDigits = value.replace(/\D/g, "");
      if (onlyDigits.length <= 10) setApplyData(prev => ({ ...prev, [name]: onlyDigits }));
    } else if (name === "name") {
      if (/^[a-zA-Z\s]*$/.test(value)) setApplyData(prev => ({ ...prev, [name]: value }));
    } else {
      setApplyData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://goforen.com/go_foren/submit_study_course_inquiry/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          study_course_id: applyData.study_course_id,
          name: applyData.name,
          mobile: applyData.number,
          email: applyData.email
        })
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Application Submitted!",
          text: result.success || "Thank you for applying.",
          confirmButtonColor: "#e38508",
        });
        setShowModal(false);
        setApplyData({ name: "", number: "", email: "", country: "" });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: result.error || "Something went wrong. Please try again.",
          confirmButtonColor: "#e38508",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not submit the form. Please try again later.",
        confirmButtonColor: "#e38508",
      });
    }
  };

  const countryOptions = [{ value: "anywhere", label: "Anywhere" }, ...countries.map(c => ({ value: c.country, label: c.country }))];
  const facultyOptions = [{ value: "any", label: "Any Faculty" }, ...studyFaculties.map(f => ({ value: f.course_name, label: f.course_name }))];
  const levelOptions = [{ value: "any", label: "Any Study Level" }, ...studyLevels.map(l => ({ value: l.level_name, label: l.level_name }))];

  return (
    <>
      <section className="pt-60 pb-60" style={{ backgroundColor: "#edf3f57a" }}>
        <div className="container">
          <h2 className="vacancy-formv-heading" style={{marginBottom:'15px'}}>Study Course</h2>
          <div className="vacancy-formv">
            <Select isMulti options={countryOptions} value={selectedCountry} onChange={setSelectedCountry} placeholder="Select Country" className='searchjobfeild'/>
            <Select isMulti options={facultyOptions} value={selectedFaculty} onChange={setSelectedFaculty} placeholder="Select Faculty of Study" className='searchjobfeild'/>
            <Select isMulti options={levelOptions} value={selectedLevel} onChange={setSelectedLevel} placeholder="Select Study Level" className='searchjobfeild'/>
            <input hidden type="text" value={collegeNature} onChange={(e) => setCollegeNature(e.target.value)} />

            <button className="submit-btnv" onClick={handleFilter}>Submit</button>
            <button className="reset-btnv" onClick={handleReset}>Reset</button>
          </div>

          <div className="row">
            <div className="col-md-12">
       <ul className="job-listv">
  {!isFilterApplied ? (
    <li className="text-center" style={{ padding: "20px", color: "#777", fontSize: "18px" }}>
      Search for the colleges or universities.
    </li>
  ) : studyCourses.length === 0 ? (
    <li className="text-center" style={{ padding: "20px", color: "#777", fontSize: "18px" }}>
      No results found for this search.
    </li>
  ) : (
    studyCourses.map(course => (
      <li className="job-previewv" key={course.id}>
        <div className="col-md-2 col-12 d-flex flex-column justify-content-center align-items-center">
          <li style={{ color: "#07374d" }}>
            <i className="fas fa-map-marker-alt"></i> {course.location}
          </li>
        </div>
        <div className="col-md-2 col-12 d-flex flex-column justify-content-center align-items-center">
          <li style={{ marginRight: "10px", color: "#e38508" }}>
            <i className="fas fa-university"></i> {course.college}
          </li>
        </div>
        <div className="col-md-2 col-12 d-flex flex-column justify-content-center align-items-center">
          <h4 className="job-titlev text-center">{course.course_name}</h4>
        </div>
        <div className="col-md-2 col-12 d-flex flex-column justify-content-center align-items-center">
          <p className="job-titlev text-center">{course.study_level}</p>
          <p className="ej-list-subv text-center">{course.seat_count}</p>
        </div>
        <div className="col-md-2 col-12 d-flex justify-content-center align-items-center">
          <a
            href={course.collage_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "underline" }}
          >
            Visit College Site
          </a>
        </div>
        <div className="col-md-2 col-12 d-flex justify-content-center align-items-center flex-column">
          <button
            onClick={() => handleApplyClick(course.id)}
            className="btnv btn-applyv"
          >
            Inquiry
          </button>
          <span className="text-muted mt-2" style={{ fontSize: "12px" }}>
            {getTimeAgo(course.created_at)}
          </span>
        </div>
      </li>
    ))
  )}
</ul>

            </div>
          </div>

          {/* <div style={{ justifyContent: "center", display: "flex", marginTop: "50px" }}>
            <button style={{ padding: "10px 20px", background: "#e38508", borderRadius: "10px" }}>
              <a style={{ color: "#fff" }} href="/StudyCourse">View More</a>
            </button>
          </div> */}

{isFilterApplied && studyCourses.length > 0 && (
  <div style={{ justifyContent: "center", display: "flex", marginTop: "50px" }}>
    <button style={{ padding: "10px 20px", background: "#e38508", borderRadius: "10px" }}>
      <a style={{ color: "#fff" }} href="/StudyCourse">View More</a>
    </button>
  </div>
)}

        </div>
      </section>

      {/* ---------- Popup Form Modal ---------- */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              width: "100%",
              maxWidth: "500px",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0 }}>Inquire Now</h3>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#999",
                }}
                title="Close"
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={applyData.name}
                onChange={handleInputChange}
                required
                style={{
                  width: "100%",
                  marginBottom: "15px",
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />

              <input
                type="text"
                name="number"
                placeholder="Whatsapp Number"
                value={applyData.number}
                onChange={handleInputChange}
                required
                style={{
                  width: "100%",
                  marginBottom: "15px",
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={applyData.email}
                onChange={handleInputChange}
                required
                style={{
                  width: "100%",
                  marginBottom: "15px",
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />

              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#e38508",
                    color: "#fff",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "5px",
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Vacancies;
